import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomButton from "../../Components/CustomButton";

import './style.css'
import { useSelector } from "react-redux";
import { placeholderImage } from "../../Assets/images";


const Profile = () => {

    const { user } = useSelector(state => state.authSlice)

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Landing List | My Profile';
    }, []);

    return (
        <>
            <DashboardLayout>
                {user ? (
                    <div className="admin-profile-shell">
                        <div className="dashCard admin-profile-hero mb-4">
                            <div className="admin-profile-heading">
                                <div className="profileImage">
                                    <img src={user?.profile_photo ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${user?.profile_photo}` : placeholderImage} alt="User" />
                                </div>
                                <div className="admin-profile-copy">
                                    <p className="admin-profile-kicker">Admin Profile</p>
                                    <h2 className="mainTitle">{user?.name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'Administrator'}</h2>
                                    <p className="admin-profile-subtitle">{user?.email}</p>
                                </div>
                            </div>
                            <div className="admin-profile-actions">
                                <CustomButton type="button" variant="primaryButton" className="me-3 mb-2" text="Edit Profile" onClick={() => { navigate('/profile/edit-profile') }} />
                                <CustomButton type="button" variant="secondaryButton" className="me-3 mb-2" text="Change Password" onClick={() => { navigate('/profile/change-password') }} />
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-lg-7">
                                <div className="dashCard h-100">
                                    <div className="admin-profile-section-header">
                                        <p className="admin-profile-section-label">Account Details</p>
                                        <h3 className="admin-profile-section-title">Identity & access</h3>
                                    </div>
                                    <div className="admin-profile-grid">
                                        <div>
                                            <h4 className="secondaryLabel">Name</h4>
                                            <p className="secondaryText">{user?.name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'Not set'}</p>
                                        </div>
                                        <div>
                                            <h4 className="secondaryLabel">Email</h4>
                                            <p className="secondaryText">{user?.email}</p>
                                        </div>
                                        <div>
                                            <h4 className="secondaryLabel">Role</h4>
                                            <p className="secondaryText">{user?.role === 'super_admin' ? 'Super Admin' : user?.role === 'neighborhood_admin' ? 'Neighborhood Admin' : 'Admin'}</p>
                                        </div>
                                        <div>
                                            <h4 className="secondaryLabel">Default Neighborhood</h4>
                                            <p className="secondaryText">{user?.defaultNeighborhood?.displayName || user?.defaultNeighborhood?.name || 'Not set'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="dashCard h-100 admin-profile-sidecard">
                                    <p className="admin-profile-section-label">Workspace Access</p>
                                    <h3 className="admin-profile-section-title">Neighborhood coverage</h3>
                                    <p className="admin-profile-sidecopy">
                                        {user?.role === 'super_admin'
                                            ? 'You currently have system-wide access across every neighborhood.'
                                            : `You have access to ${(user?.assignedNeighborhoods || []).length || 0} neighborhood${(user?.assignedNeighborhoods || []).length === 1 ? '' : 's'}.`}
                                    </p>
                                    <div className="admin-profile-chipset">
                                        {user?.role === 'super_admin' ? (
                                            <span className="badge bg-dark">All Neighborhoods</span>
                                        ) : (
                                            (user?.assignedNeighborhoods || []).map((item) => (
                                                <span key={item._id} className="badge bg-light text-dark admin-profile-chip">
                                                    {item.displayName || item.name}
                                                </span>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </DashboardLayout>
        </>
    );
};

export default Profile;
